import type { UserType, LoggedInUser, AppUpdatesAuthType } from '../types';

export interface AuthStateType {
  user: UserType | null;
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser | undefined;
}

export const INITIAL_AUTH_STATE: AuthStateType = {
  user: null,
  isLoggedIn: false,
  loggedInUser: undefined,
};

export function deriveUserFields(
  user: UserType | null,
): Pick<AuthStateType, 'isLoggedIn' | 'loggedInUser'> {
  if (!user) {
    return { isLoggedIn: false, loggedInUser: undefined };
  }
  return {
    isLoggedIn: true,
    loggedInUser: {
      id: user.account_id,
      publicName: user.name || user.nickname || user.email || '',
      avatar: user.picture || '',
      email: user.email,
    },
  };
}

export const authReducer = (
  state: AuthStateType,
  action: AppUpdatesAuthType,
): AuthStateType => {
  switch (action.type) {
    case 'AUTHENTICATE': {
      const user = action.payload.user;
      return {
        user,
        ...deriveUserFields(user),
      };
    }

    default:
      return state;
  }
};
